import { render, staticRenderFns } from "./SettingInfo.vue?vue&type=template&id=54a64346"
import script from "./SettingInfo.vue?vue&type=script&lang=js"
export * from "./SettingInfo.vue?vue&type=script&lang=js"
import style0 from "./SettingInfo.vue?vue&type=style&index=0&id=54a64346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports